import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { SaveLicense as SaveLicenseReducer } from '../../reducers/r_index';
import { SendLicenseDetails as SendLicenseDetailsReducer } from '../../reducers/r_index';
import { CreateLicense as CreateLicenseReducer } from '../../reducers/r_index';
import { GenPK as GenPKReducer } from '../../reducers/r_index';
import { GenSN as GenSNReducer } from '../../reducers/r_index';
import { CheckSN as CheckSNReducer } from '../../reducers/r_index';
import { ManageModuli as ManageModuliReducer } from '../../reducers/r_index';


import { MultiViewGestioneLicenze as MultiViewReducer } from '../../reducers/r_index';



//Components
import CreaLicenzaCmp from '../../components/gestione_licenze/CreaLicenzaCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});

class CreaLicenza extends Component {

    async componentDidMount() {
        await this.props.initializeNewLicenseData(new Date().getFullYear().toString().substr(-2));
    }

    componentDidUpdate(propsPrecedenti) {

        //uso codici_utente come flag per capire se è terminata la chiamata al web service per l'inizializzazione dei campi
        if (this.props.codici_utente !== propsPrecedenti.codici_utente) {

            this.props.handleChangeFieldSN('sn_due_cifre', (this.props.new_license.sn).substring(0, 2));
            this.props.handleChangeFieldSN('sn_quattro_cifre', (this.props.new_license.sn).substring(2, 6));
        }
    }

    render() {
        const { ...props } = this.props;

        return (
            <CreaLicenzaCmp {...props} />
        );

    }
}

CreaLicenza.propTypes = {
    //saveLicense
    saveLicense: PropTypes.func.isRequired,
    saveLicenseRequestStatus: PropTypes.string.isRequired,
    saveLicenseErrorMessage: PropTypes.string,
    isInserted: PropTypes.string.isRequired,

    //sendLicenseDetails
    sendLicenseDetails: PropTypes.func.isRequired,
    sendLicenseDetailsStatus: PropTypes.string.isRequired,
    sendLicenseDetailsErrorMessage: PropTypes.string,
    isSent: PropTypes.string.isRequired,



    new_license: PropTypes.shape({
        tipologia: PropTypes.string,
        pk: PropTypes.string,
        sn: PropTypes.any,
        codice_utente: PropTypes.string,
        multiazienda: PropTypes.bool,
        codice_azienda: PropTypes.string,
        cliente: PropTypes.string,
        email: PropTypes.string,
        data_scadenza: PropTypes.any,
        hasScadenza: PropTypes.bool,
    }).isRequired,


    //createLicenseData
    initializeNewLicenseData: PropTypes.func.isRequired,
    newLicenseDataRequestStatus: PropTypes.string.isRequired,
    initializeField: PropTypes.func.isRequired,
    handleChangeField: PropTypes.func.isRequired,
    validateField: PropTypes.func.isRequired,
    validateSN: PropTypes.func.isRequired,

    isChanged: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,

    errorText: PropTypes.shape({}).isRequired,

    resetCreateLicense: PropTypes.func.isRequired,

    codici_utente: PropTypes.arrayOf(PropTypes.string).isRequired,

    //genPK
    genPK: PropTypes.func.isRequired,
    genPKRequestStatus: PropTypes.string.isRequired,
    product_key: PropTypes.string.isRequired,

    //genSN
    genSN: PropTypes.func.isRequired,
    handleChangeFieldSN: PropTypes.func.isRequired,
    genSNRequestStatus: PropTypes.string.isRequired,
    sn_due_cifre: PropTypes.string.isRequired,
    sn_quattro_cifre: PropTypes.string.isRequired,

    //checkSN
    checkSN: PropTypes.func.isRequired,
    checkSNRequestStatus: PropTypes.string.isRequired,
    is_sn_valid: PropTypes.bool.isRequired,

    changeViewSelection: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,

    //manageModuli
    initializeFieldModuli: PropTypes.func.isRequired,
};


const mapDispatchToProps = dispatch => ({
    saveLicense: (new_license) => { dispatch(SaveLicenseReducer.creators.saveLicenseRequest(new_license)); },

    sendLicenseDetails: (pk, email) => { dispatch(SendLicenseDetailsReducer.creators.sendLicenseDetailsRequest(pk, email)); },

    //newLicenseData
    initializeNewLicenseData: (anno) => { dispatch(CreateLicenseReducer.creators.initializeNewLicenseDataRequest(anno)) },
    initializeField: (field, value) => { dispatch(CreateLicenseReducer.creators.initializeField(field, value)) },
    handleChangeField: (field, newValue) => { dispatch(CreateLicenseReducer.creators.handleChangeField(field, newValue)) },
    validateField: (field) => { dispatch(CreateLicenseReducer.creators.validateField(field)) },
    validateSN: (is_sn_valid) => { dispatch(CreateLicenseReducer.creators.validateSN(is_sn_valid)) },

    resetCreateLicense: () => { dispatch(CreateLicenseReducer.creators.resetCreateLicense()) },

    //genPK
    genPK: () => { dispatch(GenPKReducer.creators.genPKRequest()); },

    //genSN
    genSN: (anno) => { dispatch(GenSNReducer.creators.genSNRequest(anno)); },
    handleChangeFieldSN: (field, newValue) => { dispatch(GenSNReducer.creators.handleChangeField(field, newValue)); },

    //checkSN
    checkSN: (sn, tipologia) => { dispatch(CheckSNReducer.creators.checkSNRequest(sn, tipologia)) },

    changeViewSelection: newView => dispatch(MultiViewReducer.creators.changeViewSelection(newView)),

    //manageModuli
    initializeFieldModuli: (field, value) => { dispatch(ManageModuliReducer.creators.initializeField(field, value)) },
});

const mapStateToProps = state => ({
    //saveLicense
    saveLicenseRequestStatus: state['save-license'].status,
    saveLicenseErrorMessage: state['save-license'].error,
    isInserted: state['save-license'].isInserted,

    //sendLicenseDetails
    sendLicenseDetailsStatus: state['send-license-details'].status,
    sendLicenseDetailsErrorMessage: state['send-license-details'].error,
    isSent: state['send-license-details'].isSent,

    //newLicenseData
    newLicenseDataRequestStatus: state['create-license-data'].status,
    codici_utente: state['create-license-data'].codici_utente,


    new_license: state['create-license-data'].new_license,

    isChanged: state['create-license-data'].isChanged,
    isValid: state['create-license-data'].isValid,

    errorText: state['create-license-data'].errorText,

    //genPK
    genPKRequestStatus: state['genera-PK'].status,
    product_key: state['genera-PK'].product_key,

    //genSN
    genSNRequestStatus: state['genera-SN'].status,
    sn_due_cifre: state['genera-SN'].sn_due_cifre,
    sn_quattro_cifre: state['genera-SN'].sn_quattro_cifre,

    //checkSN
    checkSNRequestStatus: state['check-SN'].status,
    is_sn_valid: state['check-SN'].is_sn_valid,


    codiceUtente: state['logged-user'].codiceUtente,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreaLicenza));